import { ViewChild } from '@angular/core';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { NgForm } from '@angular/forms';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';

@Injectable({
  providedIn: 'root'
})
export class TarefasRelatoriosService extends FgiBackEndService<any> {

  @ViewChild('formTarefasRelatorios', {static: false}) form: NgForm;

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/relatorios';
  }

  gerarRelatoriosResgatesUniao2022EmDiante(gravarMemoria: boolean): Observable<any> {
    const params = new HttpParams()
      .append('gravarMemoria', gravarMemoria);
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/relatorio-resgates-uniao-2022-em-diante`;
    return this.http.get(url, { params, headers, responseType: 'text'}) as Observable<any>;
  }

  gerarRelatorioTaxaMediaMaxima(ideJanelaApuracao: number, params: any): Observable<RetornoMensagemSimplesDTO> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-taxa-media-maxima/janela/${ideJanelaApuracao}`, {params: params}) as Observable<RetornoMensagemSimplesDTO>;
  }

  reabrirJanelaApuracaoTaxaMediaMaxima(ideJanelaApuracao: number): Observable<RetornoMensagemSimplesDTO> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-taxa-media-maxima/janela/${ideJanelaApuracao}/reabrir`) as Observable<RetornoMensagemSimplesDTO>;
  }

  gerarRelatorioSaldoGarantidoCreditoLivre(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-saldo-garantido/credito-livre`, options) as Observable<any>;
  }

  gerarRelatorioSaldoGarantidoRepasse(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-saldo-garantido/repasse`, options) as Observable<any>;
  }

  gerarRelatorioConfrontoContabilCreditoLivre(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-confronto-contabil/credito-livre`, options) as Observable<any>;
  }

  gerarRelatorioConfrontoContabilRepasse(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-confronto-contabil/repasse`, options) as Observable<any>;
  }


  gerarRelatorioLimiteExposicao(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/relatorio-limite-exposicao`, options) as Observable<any>;
  }

  gerarRelatorioPengCreditoLivre(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/relatorio-apuracao-peng/credito-livre`) as Observable<any>;
  }

  gerarRelatorioPengRepasse(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/relatorio-apuracao-peng/repasse`) as Observable<any>;
  }

  atualizarBaseOperacoesInformacaoRisco(cnpjInfoRisco: string): Observable<any> {
    const params = new HttpParams().append('cnpj', cnpjInfoRisco);
    return this.http.get(`${this.BASE_URL}/atualizar-base-operacoes-informacao-risco`, {params}) as Observable<any>;
  }

}
